<!-- 服务延期 -->
<template>
	<div>
		<el-dialog title="服务延期申请：尊敬的用户，您有【1次】延期申请西联系统运维服务的机会" :close-on-click-modal="false" v-el-drag-dialog :visible.sync="dialogVisible"
			@close="changeClose">
			<el-form :model="submitForm" label-width="95px" :rules="submitRules" ref="submitFormRef"
				v-loading="loading">
				<el-form-item label="延期至：">
					<div>{{submitForm.expirationTime}}</div>
				</el-form-item>
				<el-form-item label="延期理由" prop="appleyContent">
					<el-input v-model="submitForm.appleyContent" placeholder="请输入延期理由" type="textarea"
						:autosize="{ minRows: 5}"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer">
				<el-button type="primary" @click="submit" :loading="loading">立即提交</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getBeforeDate
	} from '@/utils'
	export default {
		data() {
			return {
				dialogVisible: false,
				// 验收表单
				submitForm: {
					appleyContent: '',
					expirationTime: this.$store.state.user.serviceExtension.applyExpirationTime || ""
				},
				submitRules: {
					appleyContent: {
						required: true,
						message: '请输入延期理由',
						trigger: 'blur'
					}
				},
				loading: false
			}
		},
		components: {},
		computed: {},
		mounted() {},
		methods: {
			open(data) {
				this.dialogVisible = true
			},

			submit() {
				this.$refs.submitFormRef.validate((valid) => {
					if (valid) {
						this.$confirm(
								`您是否确定申请服务延期?`,
								'提示', {
									confirmButtonText: '确定',
									cancelButtonText: '取消',
									type: 'warning'
								}
							)
							.then(() => {
								this.loading = true;
								this.$api.home.applyAdd({
										...this.submitForm
									})
									.then(({
										data
									}) => {
										this.loading = false
										if (data.code == 200) {
											this.$notify.success({
												title: '提示',
												message: '您提交的服务延期申请已受理，我们会及时反馈审批结果，感谢您对西联软件的支持！'
											})
											this.dialogVisible = false
										}
									})
									.catch(() => {
										this.loading = false
									})
							})
							.catch(() => {})
					} else {
						return false
					}
				})
			},

			changeClose() {
				this.$refs.submitFormRef.resetFields()
			}
		}
	}
</script>

<style lang='scss' scoped>
	/deep/ .el-form-item__content {
		margin-left: 0 !important;
	}
</style>
